import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import { USER_INFO_KEY } from "../constants/common";
import { identify, reset } from "../services/analytics";

export const resolveIdentity = (userDetails, rawUser) => {
  let user = {};
  try {
    user = JSON.parse(rawUser || "{}");
  } catch {
    user = {};
  }

  const userInfo = get(user, "userInfo");
  const storeUserId = get(userDetails, [0, "UserId"]);
  if (!userInfo || !userInfo.userId || !storeUserId) return null;

  return {
    id: String(userInfo.userId),
    traits: {
      userType: user.userType || "",
      planName: get(userDetails, "0.PlanName"),
      planPeriod: get(userDetails, "0.period"),
    },
  };
};

export const identityKey = (identity) =>
  [
    identity.id,
    identity.traits.userType,
    identity.traits.planName,
    identity.traits.planPeriod,
  ].join("|");

const useAnalyticsIdentify = () => {
  const userDetails = useSelector((state) => state.userProfile.userDetails);
  const lastKey = useRef(null);

  useEffect(() => {
    try {
      const identity = resolveIdentity(
        userDetails,
        typeof localStorage !== "undefined"
          ? localStorage.getItem(USER_INFO_KEY)
          : null,
      );

      if (!identity) {
        if (lastKey.current) {
          reset();
          lastKey.current = null;
        }
        return;
      }

      const key = identityKey(identity);
      if (key === lastKey.current) return;

      identify(identity.id, identity.traits);
      lastKey.current = key;
    } catch {
      return;
    }
  }, [userDetails]);
};

export default useAnalyticsIdentify;
